import React from 'react';
import StatCard from '../common/StatCard';
import { Users, TrendingUp, ThumbsUp, Globe } from 'lucide-react';

const WhyCustMax = () => {
  const stats = [
    {
      title: 'User Growth',
      value: '500k+',
      description: 'Global users and counting',
      icon: <Users className="h-8 w-8 text-blue-600" />,
      color: 'from-blue-50 to-blue-100',
    },
    {
      title: 'Open Rate Improvement',
      value: '43%',
      description: 'Average increase with AI',
      icon: <TrendingUp className="h-8 w-8 text-green-600" />,
      color: 'from-green-50 to-green-100',
    },
    {
      title: 'Customer Satisfaction',
      value: '96%',
      description: 'Happy with our platform',
      icon: <ThumbsUp className="h-8 w-8 text-purple-600" />,
      color: 'from-purple-50 to-purple-100',
    },
    {
      title: 'Global Reach',
      value: '190+',
      description: 'Countries and regions',
      icon: <Globe className="h-8 w-8 text-amber-600" />,
      color: 'from-amber-50 to-amber-100',
    },
  ];

  return (
    <div className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Why CustMax?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Join thousands of businesses worldwide who trust us to grow their customer base.
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <StatCard 
              key={index}
              title={stat.title}
              value={stat.value}
              description={stat.description}
              icon={stat.icon}
              gradientColors={stat.color}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyCustMax;